import { render, staticRenderFns } from "./Presentations.vue?vue&type=template&id=731e56e9&scoped=true&"
import script from "./Presentations.vue?vue&type=script&lang=js&"
export * from "./Presentations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731e56e9",
  null
  
)

export default component.exports